import React, { useEffect, useState } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './AddMembersModal.module.scss';
import 'react-datepicker/dist/react-datepicker.css';
import plusIcon from '../../../assets/Imagess/plus-icon.svg';
import closeGreen from '../../../assets/Imagess/close-green.svg';
import checkIcon from '../../../assets/Imagess/check-icon.svg';
import { isEmpty, debounce } from 'lodash';
import { useFetchTeams } from '../../../Hooks/Teams';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { toast } from 'react-toastify';
import { useToast } from '../Custom/CustomToaster/Toast';
import Loader from '../Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
import Buttons from '../../Atoms/Buttons/Buttons';

const AddMembersModal = ({ handleOnClose, title, id, refetchProgram }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const customizedToast = useToast();
  const {
    data: users,
    refetch,
    isLoading,
  } = useFetchTeams(page, pageSize, searchTerm);

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  const handleSelect = (item) => {
    setSelectedItems([...selectedItems, item]);
  };

  const handleSearch = debounce(() => {
    setPage(1);
    refetch();
  }, 300);

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
    handleSearch.cancel(); // Clear debounce timeout
  };

  const deselectItem = (item) => {
    const updatedSelectedItems = selectedItems.filter(
      (selectedItem) => selectedItem !== item
    );
    setSelectedItems(updatedSelectedItems);
  };

  const addMembers = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL + `/api/Degree/BulkDegreeFacultyLinks`,
        fields,
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: () => {
      customizedToast.open('Members Added Successfully!');
      handleOnClose();
      refetch();
      refetchProgram();
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleAdd = () => {
    const facultyIds = selectedItems.map((item) => item.facultyId);
    const degreeId = id;
    const result = {
      facultyId: facultyIds,
      degreeId: degreeId,
    };

    addMembers.mutate(result);
  };

  return (
    <Modal
      onClose={handleOnClose}
      title="إضافة أعضاء"
      width="1172px"
      closeWhite={false}
      modalContainerStyle={{
        justifyContent: 'flex-end',
        padding: 0,
        alignItems: 'unset',
      }}
      onClickSaveButton={handleAdd}
    >
      <div className={styles.buttonCont}>
        <Buttons rounded={true} text="حفظ الأعضاء" handleOnClick={handleAdd} />
      </div>

      <div className={styles['modal-container']}>
        <div className={styles['search-container']}>
          <input
            placeholder="الاسم"
            className={styles['member-search']}
            value={searchTerm}
            onChange={handleSearchTermChange}
          />
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {users?.data?.items.map((item, index) => (
                <div className={styles['member-container']} key={index}>
                  <div className={styles['image-container']}>
                    <img
                      src={sanitizeAndValidateUrl(
                        `${item?.url}${item?.facultyImage}`
                      )}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = noImageFound;
                      }}
                      className={styles['image']}
                    />
                    <p>{item?.fullName_AR}</p>
                  </div>
                  {!selectedItems.includes(item) ? (
                    <img
                      className={styles['plus-icon']}
                      src={plusIcon}
                      onClick={() => handleSelect(item)}
                    />
                  ) : (
                    <img
                      className={styles['plus-icon']}
                      src={checkIcon}
                      onClick={() => deselectItem(item)}
                    />
                  )}
                </div>
              ))}
            </>
          )}
        </div>
        <div className={styles['added-members']}>
          <div className={styles['table-container']}>
            <table className={styles['custom-table']}>
              <thead>
                <tr>
                  <th
                    className={styles['header-cell']}
                    style={{
                      borderBottom: isEmpty(selectedItems)
                        ? 'unset'
                        : '1px solid #0da06e',
                    }}
                  >
                    {selectedItems?.length} الأعضاء المختارون
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedItems?.map((item, index) => (
                  <tr key={index}>
                    <td className={styles['data-cell']}>
                      <div className={styles['selected-item']}>
                        <img
                          src={sanitizeAndValidateUrl(
                            `${item?.url}${item?.facultyImage}`
                          )}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = noImageFound;
                          }}
                          className={styles['image']}
                        />
                        <p>{item?.fullName_AR}</p>
                        <img
                          src={closeGreen}
                          className={styles['close-green']}
                          onClick={() => deselectItem(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddMembersModal;
